import React from "react";
import styles from "./TableComponents.module.scss";

type ElementProps<T extends keyof React.JSX.IntrinsicElements> =
  React.JSX.IntrinsicElements[T] & {
    className?: string;
  };

export function Table({className = "", ...props}: ElementProps<"table">) {
  return (
    <table
      className={[styles.table, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}

export function TableHeader({className = "", ...props}: ElementProps<"thead">) {
  return (
    <thead
      className={[styles.thead, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}

export function TableBody({className = "", ...props}: ElementProps<"tbody">) {
  return (
    <tbody
      className={[styles.tbody, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}

export function TableFooter({className = "", ...props}: ElementProps<"tfoot">) {
  return (
    <tfoot
      className={[styles.tfoot, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}

export function TableRow({className = "", ...props}: ElementProps<"tr">) {
  return (
    <tr
      className={[styles.tr, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}

export function TableHead({className = "", ...props}: ElementProps<"th">) {
  return (
    <th
      className={[styles.th, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}

export function TableCell({className = "", ...props}: ElementProps<"td">) {
  return (
    <td
      className={[styles.td, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}

export function TableCaption({
  className = "",
  ...props
}: ElementProps<"caption">) {
  return (
    <caption
      className={[styles.caption, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}
